<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong-->
<!--        >,-->
<!--        <strong>{{ $_.get(activity, "payload.userName") }}</strong>-->
<!--        removed from-->
<!--        <strong>{{ $_.get(activity, "payload.name") }} </strong>-->
<!--        department.-->
        <span v-html="$t('notification.userRemovedToDepartment', {user1:$_.get(activity, 'actorUser.name'), user2: $_.get(activity, 'payload.userName'),department: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserRemovedFromDepartment",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
